import React from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core';

import { SearchableSelect } from '../../../UI';
import { useUserClinics } from '../../../../hooks/useUserClinics';

const styles = makeStyles({
    input: {
        height: '18px',
        padding: '6px !important'
    }
});

const SelectionClinic = ({ label, handleSelectClinic }) => {
    const classes = styles();
    const options = useUserClinics();

    return (
        <SearchableSelect
            width="100%"
            optionalToUse
            options={options}
            optionsLabel="name"
            label={label}
            name="clinic"
            customClasses={classes}
            setValue={(id, name) => {
                handleSelectClinic({ id, name });
            }}
            hasValidation={false}
        />
    );
};

SelectionClinic.propTypes = {
    label: PropTypes.string,
    handleSelectClinic: PropTypes.function
};

export default SelectionClinic;
